import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "titleDashboard" }
const _hoisted_3 = {
  key: 1,
  class: "mt-8"
}
const _hoisted_4 = { class: "textDashboard" }

import {  Ref, ref, computed, onMounted, } from 'vue';
import type { PropType } from 'vue';
import router from '@/router';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import { useStore } from 'vuex';
import { LABELS, STRING_GENERAL } from '@/constants/labels';
import { COLOR } from '@/constants/colors';

/********************************
 ********** COMPONENTS **********
 *******************************/
import GaugeComponent from '@/components/SmartLink/dashboard/GaugeComponent.vue';
import TimeLineAlerts from '@/components/SmartLink/dashboard/TimeLineAlerts.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleCard from '@/components/SmartLink/topology/SingleCard.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { KPI_COMP, OBJ_ALARM_TYPE, OBJ_TYPE_STATUS } from '@/interfaces/SmartLink/Equipos';

// KPI-Component.vue (<script setup lang="ts">)

export default /*@__PURE__*/_defineComponent({
  __name: 'KPI-Component',
  props: {
    countEquipStatus  : { type: Object as PropType<OBJ_TYPE_STATUS>, required: true },
    alarmData         : { type: Object as PropType<OBJ_ALARM_TYPE>, default: () => ({ distri: [], acceso: [], client: [] }) },
    operabilityData   : { type: Object, default: () => ({
        distribución: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
        acceso: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 },
        cliente: { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 }
    }) }
},
  setup(__props) {

const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { mdAndDown, smAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** CONSTANTES **********
 *******************************/
const props = __props;

// Construcción reactiva usando las alertas normales (props.alarmData)
const finalItemsKPI = computed<KPI_COMP>(() => ({
    distri: { valor: STRING_GENERAL.distri, alarm: props.alarmData.distri, total: props.operabilityData.distribución, count: props.countEquipStatus.distri, showError: false },
    acceso: { valor: STRING_GENERAL.access, alarm: props.alarmData.acceso, total: props.operabilityData.acceso, count: props.countEquipStatus.acceso, showError: false },
    client: { valor: STRING_GENERAL.client, alarm: props.alarmData.client, total: props.operabilityData.cliente, count: props.countEquipStatus.client, showError: false },
}));

const width     = ref('425');
const height    = ref(160);

/**
 * Muestra el componente entero una vez se haya cargado toda la información
 */
const showTotalItems = computed(() => 
  Boolean(props.operabilityData?.cliente) || props.alarmData.client.length > 0
);



/**
 * Cuando se le da click a alguno de los números, redirecciona a la vista
 * de topología de red, desplazando hasta el subtipo especificado
 * @param viewPage Subtipo de los equipos
 */
const goToTopology = (viewPage:string) => {
    router.push(`/smartlink/topology#${viewPage}`)
}



return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (showTotalItems.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_sheet, {
          color: "bgtopology",
          class: "defaultCard"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              class: "no-gutters",
              justify: "center"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalItemsKPI.value, (item, i) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    cols: "12",
                    md: "6",
                    lg: "4",
                    key: i
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)(`labels.${item.valor}`)), 1),
                      _createVNode(_component_v_row, { class: "mt-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                class: "cardSingleKPI",
                                onClick: ($event: any) => (goToTopology(item.valor)),
                                heigth: height.value,
                                bottomText: _unref(t)('labels.ok_pl'),
                                icon: 'mdi-check',
                                "color-icon": _unref(COLOR).green,
                                middleText: item.count.ok.toString()
                              }, null, 8, ["onClick", "heigth", "bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                class: "cardSingleKPI",
                                onClick: ($event: any) => (goToTopology(item.valor)),
                                heigth: height.value,
                                bottomText: _unref(t)('labels.alert_pl'),
                                icon: 'mdi-lightbulb-on-outline',
                                "color-icon": _unref(COLOR).yellow,
                                middleText: item.count.alert.toString()
                              }, null, 8, ["onClick", "heigth", "bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                class: "cardSingleKPI",
                                onClick: ($event: any) => (goToTopology(item.valor)),
                                heigth: height.value,
                                bottomText: _unref(t)('labels.alarm_pl'),
                                icon: 'mdi-exclamation-thick',
                                "color-icon": _unref(COLOR).red,
                                middleText: item.count.alarm.toString()
                              }, null, 8, ["onClick", "heigth", "bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(SingleCard, {
                                class: "cardSingleKPI",
                                onClick: ($event: any) => (goToTopology(item.valor)),
                                heigth: height.value,
                                bottomText: _unref(t)('labels.down_pl'),
                                icon: 'mdi-close',
                                "color-icon": _unref(COLOR).greyfake,
                                middleText: item.count.down.toString()
                              }, null, 8, ["onClick", "heigth", "bottomText", "color-icon", "middleText"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, { justify: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            color: "transparent",
                            width: _unref(smAndDown) ? 500 : 395,
                            height: "460"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                class: "pa-0",
                                style: {"height":"460px","align-content":"center"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(GaugeComponent, {
                                    recharge: false,
                                    "array-items": item.total,
                                    valorCard: item.valor
                                  }, null, 8, ["array-items", "valorCard"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["width"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_v_row, { justify: "center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_sheet, {
                            color: "transparent",
                            width:  width.value,
                            class: _normalizeClass(_unref(mdAndDown) ? 'pb-3' : 'pr-2')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(_unref(t)('labels.msn')), 1),
                              (item.alarm.length > 0)
                                ? (_openBlock(), _createBlock(TimeLineAlerts, {
                                    key: 0,
                                    "array-items": item.alarm,
                                    width: 400,
                                    height: height.value
                                  }, null, 8, ["array-items", "height"]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('noAlertsAlarm')), 1)
                                  ]))
                            ]),
                            _: 2
                          }, 1032, ["width", "class"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(_component_v_sheet, {
        key: 1,
        color: "bgtopology",
        class: "defaultCard text-center"
      }, {
        default: _withCtx(() => [
          _createVNode(Prog_circular)
        ]),
        _: 1
      }))
}
}

})